<template lang="pug">
  v-card(
    variant="outlined"
  ).c-voucher
    v-row(v-if="item").sub-voucher
      v-col(cols=4, sm=3).pa-0
        div.img-promotion
          v-img(
            :src="item.image_url",
            cover
          )
          div.mt-2.desc.code-promotion: code {{ item.code }}
      v-col(cols=8, sm=9, align="left").d-flex.flex-column
        h3.header {{ item.name }} <span class ="sub-header" v-if ="item.is_private"> ({{ $t('only-you') }}) </span>
        div(class="desc").px-4 {{ item.description }}
        div(class="desc") {{ $t('condition') }}
        div(class="desc").px-2
          ul(class="sub-desc", :class="{'big-sub-desc': bigSubDesc}")
            li(
              v-for='(condition, j) in getCondition(item)'
              key=j
            ) 
              | {{ condition }}
        div.d-flex.justify-space-between.px-3.content-footer.flex-sm-row.flex-column
          span.sub-desc.align-self-end
            | {{ $t('end-date') }} {{ item.expired_at | dateOnlyFormat }}
          v-btn(
            id="custom-disabled"
            color='var(--btn-select-activate-v2)'
            :disabled="!actionActive(item)"
            :loading="actionLoadding"
            dark
            depressed
            @click="redeem(item)"
          ).align-self-end.desc {{ getAcionText(item) }}
    dialog-add-voucher-success(ref='rDialogSuccess')

</template>
<script>   
import dialogAddVoucherSuccess from '@/views/Vouchers/childs/DialogAddVoucherSuccess'
import { dateFormat } from '@/plugins/time' 
import { vouchers as apiVouchers } from '@/apis'
import { ROUTE_DEPOSIT } from '@/const/route'

export default {
  components:{
    dialogAddVoucherSuccess
  },
  props : {
    item : {
      type : Object,
      default : ()=>{}
    },
    prePromotion : {
      type: Boolean,
      default: false,
    },
    bigSubDesc : {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    actionLoadding: false,
  }),
  computed : { 
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
  },   
  async mounted () {
  },
  methods : { 

    getCondition (item) {
      const conditions = []
      const rules = item.rules
      const user_progress = item.user_progress

      if (rules.start_date && rules.end_date) {
        const timeConditoin = this.$t('desc.condition-time', {'start': dateFormat(rules.start_date), 'end': dateFormat(rules.end_date)})
        conditions.push(timeConditoin);
      }

      if (rules.game_type) {
        conditions.push(this.$t('desc.condition-game-type', {'name': rules.game_type.name}));
      }
      
      if (rules.topup_amount) {
        conditions.push(this.$t('desc.condition-topup', {'amount': this.$options.filters.currency(rules.topup_amount), 'user_amount': this.$options.filters.currency(user_progress.amount) }));
      }

      if (rules.staked_threshold) {
        conditions.push(this.$t('desc.condition-staked', {'amount': this.$options.filters.currency(rules.staked_threshold), 'user_amount': this.$options.filters.currency(user_progress.bet_amount)}));
      }

      if (rules.list_amount)
      {
        conditions.push(this.$t('desc.condition-list-amount', {'amount': rules.list_amount, 'user_amount': user_progress.list_amount}));
      }

      if (rules.total)
      {
        conditions.push(this.$t('desc.condition-total', {'amount': rules.total, 'user_amount': this.$options.filters.currency(user_progress.amount)}));
      }

      if (rules.max_redeem_amount) {
        conditions.push(this.$t('desc.condition-max-redeem-amount', {'amount': this.$options.filters.currency(rules.max_redeem_amount)}));
      }

      return conditions
    },

    actionActive (item) {

      if (this.prePromotion && !item.is_need_unlock) {
        return item.is_can_active
      }

      return item.is_can_active && item.is_condition_ok
    },

    getAcionText (item) {  

      if (item.is_need_unlock) {

        if (item.is_expired) {
          return this.$t('button.is-need-unlock-expired')
        }

        return this.$t('button.is-need-unlock')
      }

      if (item.is_activated) {
        return this.$t('button.is-activated')
      }

      if (item.is_quota_full) {
        return this.$t('button.is-quota-full')
      }

      if (item.is_quota_full_today) {
        return this.$t('button.is-quota-full-today')
      }

      return this.$t('button.is-can-active', {credit: item.amount})
    },

    async redeem (item) {

      if (this.prePromotion) {
        localStorage.setItem('selectedVoucher', JSON.stringify(item))
        localStorage.setItem('currentPurchasedAmount', this.userProfile.wallet.purchased_amount)
        this.$router.push({ name: ROUTE_DEPOSIT, query: { type: 'pre-promotion' } }).catch(() => {}); 
        return
      }

      this.actionLoadding = true

      const form = {
        code: item.code
      }

      const [err,data,,,status] = await apiVouchers.redeem(form)
      this.actionLoadding = false

      if (status == 423) {
        return
      }
      
      if(err) { 
        this.$alert('',err,'warning')  
        return
      }

      data.image = item.image_url
      data.is_need_unlock = item.is_need_unlock

      this.$refs.rDialogSuccess.open(data)
      this.load()
    },

    goToDeposit () {
      this.GA('Deposit','')
      this.$router.push({
        name: ROUTE_DEPOSIT
      })
    },
  }
}
</script> 
<style scoped>

img {
  width: 100%;
  height: 100%;
}

code {
  background-color: rgba(0, 0, 0, 0.4) !important;
  color: white !important;
}

.c-voucher {
  height: 100%;
  width: 99%;

  -webkit-mask-image: radial-gradient(circle at 12% 10px, transparent 10px, red 10.5px), radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
  -webkit-mask-size: 100%, 8px 14px;
  -webkit-mask-repeat: repeat, repeat-y;
  -webkit-mask-position: 0 -10px, 23.75%;
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  background-color: var(--bg-nav-main-color) !important;
}

.sub-voucher {
  height: 100%;
}

.img-promotion {
  max-width: 100%;
  width: 300px;
  height: 100%;
  border-radius: 4px;
  position: relative;
}

.img-promotion .v-image {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.code-promotion {
  display: flex;
  justify-content: center;
  z-index: 1;
  position: absolute;
  left: 0;
  bottom: 12px;
  width: 100%;
  border-radius: 4px;
}

.header {
  font-size: 20px;
  color: white !important;
}

.sub-header {
  font-size: 20px;
  color: var(--btn-show-same-number-v2) !important;
}

.desc {
  font-size: 14px;
  color: white !important;
}

.sub-desc {
  font-size: 12px;
  color: white !important;
}

.big-sub-desc {
  font-size: 14px !important;
  color: white !important;
}

.rotate-text {
  writing-mode: tb-rl;
  transform: rotate(-180deg);
  font-size: 20px;
}

.content-footer {
  margin-top: auto;
  padding-top: 10px;
}

#custom-disabled.v-btn--disabled.theme--light {
  background-color: var(--bg-main-color-3-v2) !important;
  opacity: 0.5;
  color: white !important;
}
#custom-disabled.v-btn--disabled.theme--dark {
  background-color: var(--btn-grey-2-v2) !important;
  opacity: 0.8;
  color: white !important;
}

@media only screen and (max-width: 799px) {
  .promotion-container {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media only screen and (max-width: 599px) {
  .c-voucher {
    -webkit-mask-image: radial-gradient(circle at 16% 10px, transparent 10px, red 10.5px), radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
    -webkit-mask-position: 0 -10px, 32.125%;
    width: calc(100vw - 7%);
  }
}

</style>